import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://lomerezco.org';
const TENANT_SLUG = process.env.REACT_APP_TENANT_SLUG || '';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (TENANT_SLUG) config.headers['x-tenant-slug'] = TENANT_SLUG;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('customer_token');
      localStorage.removeItem('customer_user');
      window.location.href = '/web';
    }
    return Promise.reject(err);
  }
);

export default api;
export { API_URL, TENANT_SLUG };
